import Gallery from "./Gallery";
import ballSortImg from '../assets/images/ball-sort.png';
import learnTamilImg from '../assets/images/learn-tamil.png';

const apps = [
  {
    name: "Learn Tamil",
    image: learnTamilImg,
    info: "Learn everyday phrases and words and challenge yourself with fun quizzes.",
    playId: "com.learntamil",
    route: "learn-tamil",
  },
  {
    name: "Spherisort",
    image: ballSortImg,
    info: "Fun, free to play, puzzle game without ads.",
    playId: "com.cc.ballsort",
    route: "ball-sort",
  },
];

const AppGallery = props => {
  const { mode = "route" } = props;
  return (
    <Gallery mode={mode} apps={apps} />
  )
}

export default AppGallery;